var _circle, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0107,
    cy: 20,
    r: 20,
    fill: "#D2D2D2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.4036,
    height: 21.4036,
    transform: "translate(11.0107 9)",
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5865 10.4977C12.6864 10.4129 12.8091 10.3594 12.9391 10.3437C13.0692 10.328 13.2011 10.3508 13.3183 10.4094L30.7087 19.1046C30.8197 19.1603 30.913 19.2456 30.9782 19.3512C31.0434 19.4568 31.0779 19.5785 31.0779 19.7026C31.0779 19.8267 31.0434 19.9484 30.9782 20.054C30.913 20.1596 30.8197 20.245 30.7087 20.3006L13.3183 28.9958C13.2011 29.0545 13.0693 29.0776 12.9392 29.062C12.8091 29.0465 12.6865 28.9931 12.5864 28.9085C12.4864 28.8239 12.4134 28.7117 12.3766 28.586C12.3398 28.4602 12.3407 28.3264 12.3792 28.2012L14.9944 19.7026L12.3792 11.204C12.3409 11.0789 12.3401 10.9453 12.377 10.8198C12.4138 10.6942 12.4867 10.5823 12.5865 10.4977ZM16.1877 20.3715L14.1182 27.1002L28.9135 19.7026L14.1182 12.305L16.1877 19.0337H23.7204C23.8978 19.0337 24.068 19.1042 24.1934 19.2297C24.3188 19.3551 24.3893 19.5252 24.3893 19.7026C24.3893 19.88 24.3188 20.0501 24.1934 20.1756C24.068 20.301 23.8978 20.3715 23.7204 20.3715H16.1877Z",
    fill: "#A5A5A5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 10.7018,
    y1: 0,
    x2: 10.7018,
    y2: 21.4036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/send-button.f8ac8fec8b199329336dbd20495c281e.svg";
export { ForwardRef as ReactComponent };